import React from 'react';

/**
 * An icon from the Font Awesome 5 webfont the CSP bundles (src/index.js imports
 * fontawesome-free 5.3.1's all.min.css, and the build ships its webfonts), never
 * an emoji or symbol character: a character draws from the system's fonts, and a
 * system with no glyph for it draws an empty button (T004, CT-15747: 🎙 and ⏺
 * beside Send showed nothing, only their titles on hover). comms_icons.test.js
 * keeps the comms views free of such characters.
 *
 * name: the Font Awesome 5.3.1 name without "fa-" ('microphone', 'trash-alt').
 * regular: the outline style (far), else solid (fas).
 * label: an icon that says something on its own (role img + aria-label); without
 * one it is decorative (aria-hidden) and its control's title / aria-label or its
 * text says what it is.
 */
export default function FaIcon({ name, regular, label, title, style, className }) {
    const cls = `${regular ? 'far' : 'fas'} fa-${name}${className ? ` ${className}` : ''}`;
    if (label) return <i className={cls} role='img' aria-label={label} title={title} style={style} />;
    return <i className={cls} aria-hidden='true' title={title} style={style} />;
}
